import { useContext, useEffect, useRef, useState } from 'react';
import { MyContext } from '../../Context/MyProvider'
import BtnLoader from '../BtnLoader';
import Lottie from 'lottie-react';
import CancelLottie from "../../assets/Lottie/canceljson.json";
import secureLocalStorage from 'react-secure-storage';
import { useTranslation } from 'react-i18next';
import { socket } from '../../socket';

const CancelModel = ({ setShowModel, data, handleFetchData }) => {
    const { t } = useTranslation();

    const { handleCallApi, setShowToast, setToastMsg } = useContext(MyContext);

    const [loading, setLoading] = useState(true);
    const [reasonList, setReasonList] = useState([]);
    const [selectReason, setSelectReason] = useState("");
    const [apiLoading, setApiLoading] = useState(false);

    const FetchRef = useRef(false);

    useEffect(() => {
        hadnleGetCancelReason();
    }, []);

    const hadnleGetCancelReason = async () => {
        if (FetchRef.current) return;
        FetchRef.current = true;
        const Response = await handleCallApi("Get", "customer/vehicle_cancel_reason");
        setReasonList(Response.data.ride_cancel_list);
        setLoading(false);
    }

    const handleCancelOrder = async () => {
        const uid = secureLocalStorage.getItem("Userid");
        setApiLoading(true);

        const ApiBody = {
            uid,
            request_id: data?.id,
            cancel_id: selectReason?.id,
            lat: data?.latitude,
            lon: data?.longitude
        }


        const Response = await handleCallApi("Post", "customer/vehicle_ride_cancel", ApiBody);
        setShowToast(true);
        setToastMsg(Response.data.message);
        if (Response.data.ResponseCode === 200) {
            setApiLoading(false);
            setShowModel("");
            handleFetchData();
            socket.emit("Vehicle_Ride_Cancel", { uid, driverid: Response?.data?.driverid });
        }

    }

    if (loading) {
        return <div className="h-[400px]">
            <BtnLoader CustomeStyle={"bg-[--bg-color]"} />
        </div>
    }

    return (
        <>

            <button onClick={() => setShowModel("")} className="absolute -top-3 -right-3 bg-[--bg-color] p-[5px] rounded-full">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18.53 17.47C18.823 17.763 18.823 18.238 18.53 18.531C18.384 18.677 18.192 18.751 18 18.751C17.808 18.751 17.616 18.678 17.47 18.531L12 13.061L6.52999 18.531C6.38399 18.677 6.19199 18.751 5.99999 18.751C5.80799 18.751 5.61599 18.678 5.46999 18.531C5.17699 18.238 5.17699 17.763 5.46999 17.47L10.94 12L5.46999 6.53005C5.17699 6.23705 5.17699 5.76202 5.46999 5.46902C5.76299 5.17602 6.238 5.17602 6.531 5.46902L12.001 10.939L17.471 5.46902C17.764 5.17602 18.239 5.17602 18.532 5.46902C18.825 5.76202 18.825 6.23705 18.532 6.53005L13.062 12L18.53 17.47Z" fill="white" />
                </svg>
            </button>

            {!selectReason && <div>
                <div className="flex items-center justify-between">
                    <div className="leading-5">
                        <h1 className="font-semibold text-[18px]">{t("Why do you want to cancel ?")}</h1>
                        <p className="text-gray-600 text-[15px]">{t("Please provide the reason for cancellation.")}</p>
                    </div>
                </div>

                <div className="mt-5">
                    {reasonList.map((item, index) => {
                        return <div key={index} onClick={() => setSelectReason(item)} className={`py-2 flex items-center justify-between gap-3 cursor-pointer border-b`}>
                            <h1>{item.title}</h1>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10 16.75C9.80802 16.75 9.61599 16.6771 9.46999 16.5301C9.17699 16.2371 9.17699 15.762 9.46999 15.469L12.94 11.999L9.46999 8.52908C9.17699 8.23608 9.17699 7.76104 9.46999 7.46804C9.76299 7.17504 10.238 7.17504 10.531 7.46804L14.531 11.468C14.824 11.761 14.824 12.2361 14.531 12.5291L10.531 16.5291C10.384 16.6771 10.192 16.75 10 16.75Z" fill="black" />
                            </svg>
                        </div>
                    })}
                </div>
            </div>}

            {selectReason && <div className="">
                <Lottie
                    className="w-full mx-auto"
                    animationData={CancelLottie}
                    loop={true}
                />

                <h1 className="font-semibold md:text-[19px] text-center">{t("Are you sure you want to cancel thi ride?")}</h1>
                <p className="text-center text-gray-800 leading-5 text-[15px]">{t("We have found captains near you, please wait for a whilw, your ride should be.")}</p>

                <div className="flex items-center gap-4 mt-5">
                    <button onClick={() => setSelectReason("")} className="w-full h-10 border border-[--bg-color] text-[--bg-color] font-bold italic rounded-[10px]">
                        {t("Back")}
                    </button>
                    <button onClick={handleCancelOrder} className="w-full h-10 bg-[--bg-color] hover:bg-[--bg-color-hover] text-white font-bold italic rounded-[10px]">
                        {apiLoading
                            ? <BtnLoader CustomeStyle={"bg-white"} />
                            : t("Yes, Cancel")}
                    </button>
                </div>

            </div>}

        </>
    )
}

export default CancelModel